import MaintenanceItems from './MaintenanceItems.vue'
export default MaintenanceItems


// WEBPACK FOOTER //
// ./src/pages/MaintenanceItems/index.js